import React from 'react';
import './ordered-alert.scss';
import DataGrid from 'devextreme-react/data-grid';
import {Button} from 'devextreme-react/button';
export default () => {
    return(
    <React.Fragment>
           <h4 className={'content-block'}>Combine Shipment</h4>
          <div id="action-buttons" className={'content-block'}>
            <Button className="m-2 lower-text" type="default" disabled={true} text="Combine Shipment"/>
            <Button className="m-2 lower-text" type="default" disabled={true} text="Dismiss"/>
          <br/>    
          </div>
          <div className={'content-block'}>
            <DataGrid/>
          </div>
        
    </React.Fragment>
  
)};